import React, { useState } from 'react';
import Editor from '@monaco-editor/react';
import yaml from "js-yaml";
import "../CodeConverter.css";
import { FaDownload, FaCompress, FaBrush, FaCopy, FaCheck, FaTrash } from "react-icons/fa";
import JsonEditorPanel from "../components/JsonEditorPanel";
import CommonSeoContent from "../components/CommonSeoContent";
import useEditorActions from "../utils/useEditorActions";

const YamlToJson = () => {
  const [inputCode, setInputCode] = useState("");
  const [outputCode, setOutputCode] = useState("");

  // Import reusable actions
  const { handleDownload, handleClear } = useEditorActions(
    setInputCode,
    outputCode,
    setOutputCode
  );

  const handleConvert = () => {
    try {
      const json = yaml.load(inputCode);
      const pretty = JSON.stringify(json, null, 2);
      setOutputCode(pretty);
    } catch (e) {
      setOutputCode("// ❌ Invalid Yaml:\n" + e.message);
    }
  };

  return (
    <div className="formatter-container">
      <h1> YAML ➝ JSON Converter</h1>

      {/* Toolbar */}
      <div className="toolbar">
        <button onClick={handleConvert} className="btn primary">
          <FaBrush /> Convert
        </button>
        <button onClick={() => handleDownload("json", "formatted-json")} className="btn success">
          <FaDownload /> Download
        </button>
		<button onClick={handleClear} className="btn danger">
          <FaTrash /> Clear
        </button>

      </div>

      {/* Editors */}
      <div className="editor-panels">
        <JsonEditorPanel title="Input Yaml" language="yaml" code={inputCode} setCode={setInputCode} />
        <div className="editor-section-empty-div">
        </div>
        <JsonEditorPanel title="Output JSON" language="json"  code={outputCode} />
      </div>
	  
	  <CommonSeoContent
  title="Online YAML to JSON Converter"
  description="Convert YAML to JSON instantly with our free online converter. Supports nested structures, arrays, and produces clean, readable JSON output for developers."
  keywords="YAML to JSON, yaml to json converter, yaml to json online, convert yaml, online yaml parser, yaml to json tool, jsonconverter.org"
  author="jsonconverter.org"
  heading="Why Use YAML to JSON Converter?"
  whyUseText="Our YAML to JSON Converter allows you to transform well-structured YAML into valid JSON instantly. Whether you're working with configuration files, Kubernetes manifests, or API specifications, this tool simplifies the process of converting to JSON — the most widely used data format across modern applications. It supports nested YAML, arrays, booleans, and more, ensuring accurate data conversion every time. All processing is done in your browser, meaning your files stay private and secure. No installation required — just fast, clean, and reliable results for developers, DevOps engineers, and system architects."
  howToUseSteps={[
    "Paste your YAML data into the input editor.",
    "Click the Convert button.",
    "Instantly view your converted JSON output.",
    "Copy or download the result for use in your project.",
  ]}
  features={[
    "Accurately converts YAML to well-structured JSON",
    "Supports complex nesting, lists, and data types",
    "Automatically handles indentation and formatting",
    "Runs entirely in-browser — no data ever leaves your device",
    "Free and easy to use — no login or signup required",
    "Option to copy or download your JSON output for offline use",
  ]}
  inputTitle="Input YAML:"
  inputExample={`name: John Doe
age: 30
emails:
  - john@example.com
  - john.doe@example.org
isActive: true`}
  outputTitle="Output JSON:"
  outputExample={`{
  "name": "John Doe",
  "age": 30,
  "emails": [
    "john@example.com",
    "john.doe@example.org"
  ],
  "isActive": true
}`}
  callToAction="Start converting your YAML to JSON instantly — no signup or install required."
/>

    </div>
  );
};

export default YamlToJson;
